module.exports = __webpack_public_path__ + "Flama-ThinItalic.woff?5baba7fdf3bcf9e997843c2a2c56583e";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-ThinItalic.woff
// module id = 933
// module chunks = 0